export default {
  pageTitle: '禁止ドメイン',
  success: '作成しました。',
  deleted: '削除しました。',
  pageTitleCreate: '禁止ドメインの追加',
  label: 'ドメイン名'
};
